<template>
  <div class="cf-flex cf-flex--column cf-flex--gap-8">
    <h4 class="cf-title cf-title--4">
      {{ merchant.name }}
    </h4>

    <p
      v-if="isStoreLocationSelected"
      class="cf-subtitle cf-subtitle--3"
    >
      {{ selectedLocation.address.line1 }},
      {{ selectedLocation.address.city }},
      {{ selectedLocation.address.state }}
      {{ selectedLocation.address.postalCode }}
    </p>
  </div>
</template>


<script>
  export default {
    name: 'LocationInformation',

    props: {
      merchant: {
        type: Object,
        required: true
      },

      selectedLocation: {
        type: Object,
        default() {
          return {};
        }
      }
    },

    computed: {
      isStoreLocationSelected() {
        return this.selectedLocation.storeId;
      }
    }
  };
</script>
